


























import {Vue, Component, Prop} from 'nuxt-property-decorator'
import {Loading} from '@frontend/components/src/Loading'

@Component({
  components: {
    Loading
  }
})
export default class PreviewAndPublish extends Vue {
  @Prop({type: String, required: true})
  readonly draftId!: string

  insightsUrl = ''

  mounted () {
    this.insightsUrl = `${process.env.VUE_APP_INSIGHTS_URL}?previewDraftId=${this.draftId}`
  }

  iframeLoading = true

  onLoad() {
    this.iframeLoading = false
  }
  refresh() {
    this.insightsUrl += '#'
  }
}
